import React, { useState, useEffect, useContext } from 'react'
import { Helmet } from 'react-helmet'
import { Spin, Empty } from 'antd'
import { getCookie } from 'helper/cookie'
import { getHelpdeskWidget } from 'api/HelpDesk'
import { CounterContext } from 'redux/Golbalvalues'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

const HelpdeskWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 112px);
  display: flex;
  flex-direction: column;
  background-color: #fff;
`

const IframeContainer = styled.div`
  flex: 1;
  width: 100%;
  overflow: hidden;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`

const LoadingContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #fff;
`

const HelpdeskComponent = () => {
  const { setPathActive } = useContext(CounterContext)
  const history = useHistory()
  const token = getCookie('access_token_admin')

  const [widgetUrl, setWidgetUrl] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // Set active path for sidebar
  useEffect(() => {
    setPathActive('/helpdesk')
  }, [setPathActive])

  // Fetch widget URL and use API response as access decision
  useEffect(() => {
    const initHelpdesk = async () => {
      try {
        setLoading(true)

        // Fetch widget URL from API
        if (!token) {
          setError('No authentication token found')
          return
        }

        const response = await getHelpdeskWidget({ token })

        if (response?.status === 200) {
          const url = response.data?.result?.redirect_url
          if (url) {
            setWidgetUrl(url)
          } else {
            setError('Widget URL not found in response')
          }
          return
        }

        if ([401, 403].includes(response?.status)) {
          history.push('/no-permission')
          return
        }

        setError('Failed to fetch helpdesk widget')
      } catch (err) {
        console.error('Error initializing helpdesk:', err)
        setError('Error loading helpdesk widget')
      } finally {
        setLoading(false)
      }
    }

    initHelpdesk()
  }, [token, history])

  return (
    <HelpdeskWrapper>
      <Helmet>
        <title>AXONS PROJECT | InApp HelpDesk</title>
      </Helmet>

      {loading ? (
        <LoadingContainer>
          <Spin size="large" tip="Loading HelpDesk..." />
        </LoadingContainer>
      ) : error ? (
        <LoadingContainer>
          <Empty description={error} />
        </LoadingContainer>
      ) : widgetUrl ? (
        <IframeContainer>
          <iframe src={widgetUrl} title="HelpDesk Widget" />
        </IframeContainer>
      ) : (
        <LoadingContainer>
          <Empty description="No widget URL available" />
        </LoadingContainer>
      )}
    </HelpdeskWrapper>
  )
}

export default HelpdeskComponent
